import { HalfStarSVG } from '@src/components/SVGS/HalfStartSvg'
import { StarSVG } from '@src/components/SVGS/StarSVG'
import { breakpoints } from '@src/constants/breakpoints'
import styled from 'styled-components'

export const StarSVGStyled = styled(StarSVG)`
  width: 18px;
  height: 18px;
  margin-right: 4px;
  color: ${({ theme }) => theme.colors.review};
`

export const ReviewHeaderRow = styled.div<{ isClickable?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  color: #939393;
  font-size: 12px;
  line-height: 15px;
  margin-top: 4px;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 16px;
    line-height: 20px;
  }

  cursor: pointer;
`

export const ReviewItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`

export const RatingStarSVGStyled = styled(StarSVG)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.review};

  @media (min-width: ${breakpoints.tablet}px) {
    width: 20px;
    height: 20px;
  }
`

export const ReviewsSheetContainer = styled.div`
  padding: 24px 20px 32px;
  color: #2e3333;
  max-height: 100%;
  overflow-y: auto;

  @media (min-width: ${breakpoints.tablet}px) {
    padding: 32px 36px 40px;
  }
`

export const ReviewList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`

export const ReviewOverviewContainer = styled.div`
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  height: 100px;
  border: 2px solid ${({ theme }) => theme.colors.review};
  margin: 28px 0;

  @media (min-width: ${breakpoints.tablet}px) {
    padding: 32px;
  }
`

export const ReviewOverviewNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`

export const ReviewOverviewStarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 3;
  align-items: flex-end;
  justify-content: space-between;
`

export const RatingBoldText = styled.div`
  font-weight: 700;
  font-size: 44px;
`

export const RatingSmallText = styled.div`
  font-size: 12px;
  color: grey;
  margin-top: 4px;
`

export const StarRatingRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;
`

export const RatingHeader = styled.span`
  font-weight: 700;
  font-size: 14px;

  @media (min-width: ${breakpoints.largeTablet}px) {
    font-size: 16px;
  }
`
export const AverageCountAndStarsContainer = styled.div`
  width: 60%;
  justify-content: space-between;
  display: flex;
`

export const StarsContainer = styled.div`
  display: flex;
  width: 75%;
  justify-content: space-between;
  align-items: center;
`

export const ReviewCard = styled.article`
  background: #f6f6f9;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (min-width: ${breakpoints.tablet}px) {
    padding: 20px;
  }
`

export const ReviewMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #6f6f6f;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 14px;
  }
`

export const ReviewRating = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: #2e3333;
  font-size: 14px;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 16px;
  }
`

export const ReviewTimestamp = styled.span`
  margin-left: auto;
  white-space: nowrap;
`

export const ReviewText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: #2e3333;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 16px;
    line-height: 22px;
  }
`

export const ReviewCategories = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  font-size: 12px;
  color: #6f6f6f;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 13px;
  }
`

export const ReviewReply = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);

  @media (min-width: ${breakpoints.tablet}px) {
    gap: 8px;
    padding: 16px;
  }
`

export const ReviewReplyLabel = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: #2e3333;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 13px;
  }
`

export const ReviewReplyText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: #4f4f4f;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 14px;
    line-height: 22px;
  }
`

export const ReviewsEmptyState = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6f6f6f;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 16px;
  }
`

export const SheetRatingStar = styled(StarSVG)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.review};

  @media (min-width: ${breakpoints.tablet}px) {
    width: 20px;
    height: 20px;
  }
`

export const SheetRatingStarHalf = styled(HalfStarSVG)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.review};

  @media (min-width: ${breakpoints.tablet}px) {
    width: 20px;
    height: 20px;
  }
`

export const ReviewCustomerName = styled.span`
  flex: 1;
  text-align: right;
  font-weight: bold;
`

export const OuterOutletDetailsReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const OutletDetailReviewContainer = styled.div`
  width: 40%;
  justify-content: center;
  display: flex;
  flex-direction: row;
`

export const ViewAllReviewsText = styled.a`
  margin-top: 4px;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`
